// extracted by mini-css-extract-plugin
export default {"ForumSearch__headline":"qs_a bii_sn bii_va","ForumSearch__img":"qs_b","ForumSearch__searchAdsAndShoppingAds":"qs_c","ForumSearch__results--empty":"qs_e"};